var React = require('react');

function User (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0.503 0.501)"},[React.createElement("ellipse",{"cx":"6.205","cy":"6.205","rx":"6.205","ry":"6.205","transform":"translate(5.911 -0.001)","fill":"none","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"1","key":0}),React.createElement("path",{"d":"M212.146,482.365c-1.335-6.35-4.61-6.075-5.228-6.134l-2.078.006a.439.439,0,0,0-.315.138,6.182,6.182,0,0,1-8.93.039.48.48,0,0,0-.345-.148l-2.256.007c-3.38-.045-4.681,4.358-5.056,6.056a.54.54,0,0,0,.53.656h23.179A.512.512,0,0,0,212.146,482.365Z","transform":"translate(-187.926 -462.669)","fill":"none","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"1","key":1})]));
}

User.defaultProps = {"width":"25.237","height":"21.317","viewBox":"0 0 25.237 21.317"};

module.exports = User;

User.default = User;
